// LPC countdown alignment fix (2026-07-11)
// The enroll-page Custom Liquid countdown targets the upcoming Saturday at 00:00 and
// jumps a full week the moment intake day starts, contradicting the page copy which
// shows today's date on intake day. This block takes over the countdown and targets
// the upcoming Saturday at 23:59:59 local time (today if Saturday), so the timer and
// the copy roll over to the next cohort together at midnight.
// Runs deferred (after the inline countdown initialises); it swaps the countdown DOM
// node so the old updater writes to detached elements, then drives the visible one.
(function () {
  try {
    if (!/\/pages\/enroll(?:$|[/?#])/.test(window.location.pathname + window.location.search)) return;
    function fixCountdown() {
      try {
        var clock = document.getElementById('countdown');
        if (!clock || !clock.parentNode) return;
        var now = new Date();
        var daysAhead = (6 - now.getDay() + 7) % 7; // 0 if today is Saturday
        var deadline = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysAhead, 23, 59, 59);
        var clone = clock.cloneNode(true);
        clock.parentNode.replaceChild(clone, clock);
        var ds = clone.querySelector('.days');
        var hs = clone.querySelector('.hours');
        var ms = clone.querySelector('.minutes');
        var ss = clone.querySelector('.seconds');
        function pad(n) { return ('0' + n).slice(-2); }
        function tick() {
          var t = deadline.getTime() - Date.now();
          if (t < 0) { t = 0; }
          if (ds) { ds.innerHTML = Math.floor(t / 86400000); }
          if (hs) { hs.innerHTML = pad(Math.floor(t / 3600000) % 24); }
          if (ms) { ms.innerHTML = pad(Math.floor(t / 60000) % 60); }
          if (ss) { ss.innerHTML = pad(Math.floor(t / 1000) % 60); }
        }
        tick();
        setInterval(tick, 1000);
      } catch (e) { /* never break the page */ }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixCountdown);
    } else {
      fixCountdown();
    }
  } catch (e) { /* never break the page */ }
})();
// End LPC countdown alignment fix


  var iFrameForm = document.querySelector('.popup-homepage');
  var overlay = document.querySelector('.overlay');
  var stopScroll = document.querySelector('.learn-photography-company');
  var closeBtn = document.querySelector('.close-popup');
  var closeBtn2 = document.querySelector('.close-btn-saf');

  
    overlay.style.visibility='visible';
    overlay.style.opacity=1;
    iFrameForm.style.display='block';
    stopScroll.classList.add('stop-scroll');
    

  overlay.addEventListener('click',function(){
    overlay.style.opacity=0;
    iFrameForm.style.display='none';
     overlay.style.visibility='hidden';
     stopScroll.classList.remove('stop-scroll');
    closeBtn.style.display='none';
  });
  closeBtn.addEventListener('click',closePopup);
  closeBtn2.addEventListener('click',closePopup);

function closePopup(){
   overlay.style.opacity=0;
    iFrameForm.style.display='none';
     overlay.style.visibility='hidden';
     stopScroll.classList.remove('stop-scroll');
    closeBtn.style.display='none';
}

$(document).ready(function() {
  function adjustPopupPosition() {
    var scrollTop = $(window).scrollTop();
    
    if (scrollTop > 0) {
      // Adjust the top position based on scroll distance
      $('.popup-homepage').css('top', 400 + scrollTop + 'px');
    }
  }

  // Adjust position on page load
  adjustPopupPosition();

  // Adjust position on scroll
  $(window).scroll(function() {
    adjustPopupPosition();
  });
});
// Home Page popup end



